import React from 'react';
const SvgMobileAvailabilityIcon = (props) => (
  <svg
    id='HowToBook_svg__Layer_2'
    data-name='Layer 2'
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox='0 0 128 128'
    {...props}
  >
    <defs>
      <style>{'.HowToBook_svg__cls-1{fill:#fff}'}</style>
    </defs>
    <g id='HowToBook_svg__Layer_1-2' data-name='Layer 1'>
      <rect
        width={128}
        height={128}
        rx={32.53}
        ry={32.53}
        style={{
          fill: '#2673b0',
        }}
      />
      <g id='HowToBook_svg__d'>
        <path
          className='HowToBook_svg__cls-1'
          d='M6 2v2H5a2.015 2.015 0 0 0-2 2v14a2.015 2.015 0 0 0 2 2h14a2.015 2.015 0 0 0 2-2V6a2.015 2.015 0 0 0-2-2h-1V2h-2v2H8V2ZM5 9h14v11H5Zm9.8 2.3-3.3 3.3-1.8-1.8-1.4 1.4 3.2 3.2 4.7-4.7Z'
          transform='matrix(3.5 0 0 3.5 24 21.5)'
        />
      </g>
    </g>
  </svg>
);
export default SvgMobileAvailabilityIcon;
